import { Collection } from "@type-r/models";
import { pureRenderProps } from "@type-r/react";
import { asTimelessDate, CollapsableSection, Column, Columns, FormInput, InlineTable, PopoverList, Subsection, TableCell, TableHeader, TableRow, TopSection } from "lqx-react";
import * as React from "react";
import { ShippingNotice } from "api";

export const Shipment =
    pureRenderProps({
        shipment : Collection.of( ShippingNotice )
    },
    ({ shipment }) =>
        <TopSection id="shipment" title="Shipping Notice">
            { shipment.map( notice =>
                <CollapsableSection id={ notice.cid } key={ notice.cid } title="Shipping Notice" info={ notice.packing_slip_number }>
                    <Columns>
                        <Column>
                            <FormInput label="Tracking Number" value={notice.package_tracking_number} />
                        </Column>
                        <Column>
                            <FormInput label="Planned delivery date" value={ asTimelessDate( notice.planned_delivery_date_utc )} />
                        </Column>
                    </Columns>
                    <Subsection title="" id="items">
                        <InlineTable
                            head={
                                <TableHeader>
                                    <TableCell>
                                        Unit/Part #
                                    </TableCell>
                                    <TableCell>
                                        Units Shipped
                                    </TableCell>
                                    <TableCell>
                                        Total Units
                                    </TableCell>
                                    <TableCell>
                                        Serial Number
                                    </TableCell>
                                </TableHeader>
                            }
                        >
                            { notice.items.map( item =>
                                <TableRow key={ item.cid } >
                                    <TableCell>
                                        {item.part_number}
                                    </TableCell>
                                    <TableCell>
                                        {item.units_shipped}
                                    </TableCell>
                                    <TableCell>
                                        { item.quantity }
                                    </TableCell>
                                    <TableCell>
                                        <PopoverList items={ item.serial_numbers } />
                                    </TableCell>
                                </TableRow>
                            )}
                        </InlineTable>
                    </Subsection>
                </CollapsableSection>
            )}
        </TopSection>
    )
